/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";

import {
  Input,
  AutoSaveField as Field,
  InputGroup,
  LinkedField,
  CustomSelect
} from "../../../../components/Form";

import { UAE_CODE, MAX_EMAIL_LENGTH } from "../../../../constants";
import { getApplicantInfo, getOrganizationInfo } from "../../../../store/selectors/appConfig";

export const CompanyContactDetails = ({ setFieldValue }) => {
  const applicantInfo = useSelector(getApplicantInfo);
  const organizationInfo = useSelector(getOrganizationInfo);

  useEffect(() => {
    organizationInfo?.contactDetails?.primaryEmail === "" &&
      setFieldValue("email", applicantInfo.email);
    if (organizationInfo?.contactDetails?.primaryMobileNo === "") {
      setFieldValue("mobileNo", applicantInfo.mobileNo);
      setFieldValue(
        "mobileCountryCode",
        organizationInfo.contactDetails?.primaryMobileNo === applicantInfo.mobileNo
          ? applicantInfo.countryCode
          : UAE_CODE
      );
    }
  }, [
    applicantInfo.countryCode,
    applicantInfo.email,
    applicantInfo.mobileNo,
    organizationInfo.contactDetails?.primaryEmail,
    organizationInfo.contactDetails?.primaryMobileNo,
    setFieldValue
  ]);

  return (
    <React.Fragment>
      <Grid container spacing={3} sx={{ mt: 0 }}>
        <Grid item sm={6} xs={12}>
          <Field
            name="email"
            path="prospect.organizationInfo.contactDetails.primaryEmail"
            label="Email Address"
            placeholder="Email"
            component={Input}
            InputProps={{
              inputProps: { maxLength: MAX_EMAIL_LENGTH, tabIndex: 0 }
            }}
          />
        </Grid>
        <Grid item sm={6} xs={12} sx={{ mt: { xs: 2, sm: 0 } }}>
          <Field
            path="prospect.organizationInfo.contactDetails.website"
            name="website"
            label="Website(optional)"
            placeholder="Website"
            component={Input}
            InputProps={{
              inputProps: { tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 0 }}>
        <Grid item sm={6} xs={12}>
          <InputGroup>
            <LinkedField
              name="mobileCountryCode"
              linkedFieldName="mobileNo"
              path="prospect.organizationInfo.contactDetails.primaryMobileCountryCode"
              linkedPath="prospect.organizationInfo.contactDetails.primaryMobileNo"
              required
              datalistId="countryCode"
              component={CustomSelect}
              shrink={false}
              inputProps={{
                inputProps: { tabIndex: 0 }
              }}
            />
            <LinkedField
              name="mobileNo"
              linkedFieldName="mobileCountryCode"
              linkedPath="prospect.organizationInfo.contactDetails.primaryMobileCountryCode"
              path="prospect.organizationInfo.contactDetails.primaryMobileNo"
              label="Mobile number"
              placeholder="Mobile number"
              component={Input}
              contextualHelpText="This number should be unique for a Company"
              InputProps={{
                inputProps: { tabIndex: 0 }
              }}
            />
          </InputGroup>
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            mt: {
              xs: 3,
              sm: 0
            }
          }}
        >
          <InputGroup>
            <LinkedField
              name="phoneCountryCode"
              linkedFieldName="phoneNo"
              path="prospect.organizationInfo.contactDetails.primaryPhoneCountryCode"
              linkedPath="prospect.organizationInfo.contactDetails.primaryPhoneNo"
              required
              datalistId="countryCode"
              component={CustomSelect}
              shrink={false}
              inputProps={{ tabIndex: 0 }}
            />
            <LinkedField
              name="phoneNo"
              linkedFieldName="phoneCountryCode"
              linkedPath="prospect.organizationInfo.contactDetails.primaryPhoneCountryCode"
              path="prospect.organizationInfo.contactDetails.primaryPhoneNo"
              label="Landline number"
              placeholder="Landline number"
              component={Input}
              contextualHelpText="This number should be unique for a Company"
              inputProps={{ tabIndex: 0 }}
            />
          </InputGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

CompanyContactDetails.propTypes = {
  setFieldValue: PropTypes.func.isRequired
};
